import * as actions from 'redux/actions/app.actions'
import { get } from 'helpers/util'

const initialState = {
  notifications: [],
  notificationsConnected: false,
  isOpenSideNav: false,
  isExpandedSideNav: localStorage.getItem('isExpandedNav') === 'true'
}

// sent, delivered
const appReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.connectAppNotifications.type:
      return {
        ...state,
        notificationsConnected: true
      }
    case actions.disconnectAppNotifications.type:
      return {
        ...state,
        notifications: [],
        notificationsConnected: false
      }
    case actions.getAppNotifications.type: {
      let history = get([payload, 'notifications', 'history', 'data'], [])
      if (!Array.isArray(history)) {
        history = [history]
      }

      const notifications = [
        ...history
          .filter(item => state.notifications.findIndex(s => s.id === item.id) === -1)
          .reverse(),
        ...state.notifications
      ]

      return {
        ...state,
        notifications
      }
    }
    case actions.readAppNotifications.type: {
      const notifications = state.notifications.map(item => {
        if (payload.uuids.includes(item.id)) {
          return {
            ...item,
            attributes: {
              ...item.attributes,
              status: 'read'
            }
          }
        }
        return item
      })
      return {
        ...state,
        notifications
      }
    }
    case actions.deleteAppNotification.type: {
      const notifications = state.notifications.filter(item => payload.uuid !== item.id)
      return {
        ...state,
        notifications
      }
    }
    case actions.onOpenSideNav.type:
      return { ...state, isOpenSideNav: true }
    case actions.onCloseSideNav.type:
      return { ...state, isOpenSideNav: false }
    case actions.onToggleSideNav.type:
      localStorage.setItem('isExpandedNav', !state.isExpandedSideNav)
      return { ...state, isExpandedSideNav: !state.isExpandedSideNav }
    case 'ROUTE_CHANGE': {
      return {
        ...state,
        isOpenAccountNav: false,
        isOpenSideNav: false
      }
    }
    default:
      return state
  }
}

export default appReducer
